import GlobalStyle from "./styles/global";

import Router from "./routes/index";
import { TechsContexts } from "./contexts/TechsContext";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddModal, LogoutModal } from "./components/Modal";
import { useContext } from "react";
import { UserContext } from "./contexts/UserContext";

function App() {
  const { showAddModal } = useContext(TechsContexts);
  const { showLogoutModal } = useContext(UserContext);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <GlobalStyle />
      {showAddModal && <AddModal />}
      {showLogoutModal && <LogoutModal />}
      <Router />
    </>
  );
}

export default App;
